// extracted by mini-css-extract-plugin
module.exports = {"SandboxPage":"SandboxPage_SandboxPage__DjfPK"};